"use client";

import CustomSelect from "@/components/ui/input/CustomSelect";
import { useCurrency } from "@/contexts/CurrencyContext";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { commonService } from "@/services/commonService";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import Spinner from "./ui/Spinner";

export default function CurrencySwitcher({ handleCurrencyChange, value }) {
  const { currencies } = useCurrency();
  const [currenciesList, setCurrenciesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const t = useTranslationDetector();

  const getCurrencies = async () => {
    try {
      setLoading(true);
      const response = await commonService.getCurrencies();
      if (response?.Currencies) {
        setCurrenciesList(response.Currencies);
      }
    } catch (error) {
      console.error("CurrencySwitcher: Error getting currencies:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCurrencies();
  }, []);

  const onChange = (e) => {
    const newCurrency = e.target.value;
    handleCurrencyChange(newCurrency);
  };

  return loading ? (
    <div className="border-border flex items-center justify-between rounded-lg border p-4">
      <span className="flex items-center gap-2">
        <span>
          <FontAwesomeIcon
            icon={byPrefixAndName.fak["banknote"]}
            className="text-[20px]"
          />
        </span>
        <span>{t("common.loading")}</span>
      </span>
      <Spinner className="h-4 w-4 animate-spin" />
    </div>
  ) : (
    <CustomSelect
      label={t("common.currencyLabel")}
      value={value}
      onChange={onChange}
      options={currenciesList}
      valueKey="CurrencyCode"
      labelKey="CurrencyName"
      renderOption={(option) => {
        return (
          <div className="flex w-full items-center justify-between gap-2">
            <span>{option.CurrencyName}</span>
            <div className="inline-flex items-center gap-2">
              <span>{option.CurrencyCode}</span>
              <span className="h-[2px] w-[2px] rounded-full bg-black"></span>
              <span>{option.CurrencySymbol}</span>
            </div>
          </div>
        );
      }}
    />
  );
}
